<script lang="ts">
	export let onClick: () => void;
</script>

<div
	class="flex justify-center items-center gap-1 rounded-md border border-fx-grey-400 bg-fx-black py-1 px-3 cursor-pointer hover:bg-fx-grey-600 transition-all duration-300"
	on:click={onClick}
	role="presentation"
>
	<p class="text-sm text-fx-white mt-0.5">Tweet</p>
	<img src="trading-season/x.webp" alt="X" class="w-5 h-5" />
</div>
